//Service 类，会创建session(me), 并且将current属性设置为 me; 以后方法需要此值



var _util = require('./Util');
var _ = require('underscore');

var _logger = _util.tagLogger("Service");


var Session = require('./Session');


var Attendee = require('./Attendee');

var __event = require('./event');
var EventHandler = require('./EventHandler');

var __Desktop = require('./_Desktop');

var __desktop = new __Desktop({
    onExtLoaded: function () {
        _logger.info("Share desktop ext. had loaded.");
    }
});

var __Stream = require('./_Stream');
var PCStats = require('./PCStats');

var DefaultMouseTrack = require('../../../pannel/src/components/DefaultTrack');

/**
 * {
 *  newSession:
 *  onCalling:
 *  onRinging:
 *
 *
 * }
 *
 *
 *
 */
module.exports = _util.prototypeExtend({
    __init__: function () {
        var self = this;

        _logger.warn("emedia version: ", window._emediaVersion || "unkown");
        _logger.warn("UserAgent: ", navigator.userAgent);

        var urlLogLevel = _util.parseURL("__log_level___");
        if(urlLogLevel){
            emedia.LOG_LEVEL = parseInt(urlLogLevel);
        }

        // if(self.ticket && _util.isPlainObject(self.ticket)){
        //     self.setup(self.ticket);
        // }

        self.namespace = Math.uuidFast();
        emedia.useCurrentXService = self;

        if(self.useRTCCfg === undefined){
            self.useRTCCfg = emedia.config.useRTCCfgIfServerReturn;
        }

        if(typeof self.useRTCCfg === "string"){
            self.useRTCCfg = JSON.parse(self.useRTCCfg);
        }

        self.inboundAudio = PCStats.inboundAudio.bind(self);
        self.inboundVideo = PCStats.inboundVideo.bind(self);
        self.outboundAudio = PCStats.outboundAudio.bind(self);
        self.outboundVideo = PCStats.outboundVideo.bind(self);

        // if(self.listeners){
        //     for(var funcName in self.listeners){
        //         var name = funcName;
        //         var func = self.listeners[name];
        //         if(typeof func === 'undefined'
        //             || name === 'onRecvRemoteMessage'
        //             || name === 'onSoundChanage'
        //             || name === 'onTalking'){
        //             continue;
        //         }
        //
        //         self.listeners["__user_" + name] = func;
        //         self.listeners[name] = (function(name, func) {
        //             return (function () {
        //                 _logger.info("sdk call user impl func. func=", name, self.current && self.current.getMemberId());
        //                 func.apply(this, arguments);
        //             })
        //         })(name, func);
        //     }
        // }

        // 接收到的session
        self._cache_receive_sessions = [];
    },

    AVPubstream: __Stream.extend({
        __init__: function () {
            var self = this;

            self.type = 0;
            self._located = true;

            self.mutedMuted = true;

            if(self.constaints){
                self.constaints.video || (self.voff = 1);
                self.constaints.audio || (self.aoff = 1);
            }
            //self.constaints || (self.constaints = {audio: !self.aoff, video: !self.voff});
            self.constaints || (self.constaints = {audio: true, video: true});

            emedia.config.maxVideoBitrate && (self.vbitrate = emedia.config.maxVideoBitrate);
            emedia.config.maxAudioBitrate && (self.abitrate = emedia.config.maxAudioBitrate);
        }
    }),

    AudioMixerPubstream: new __Stream.extend({
        __init__: function () {
            var self = this;

            self.type = 2;
            self._located = true;

            self.mutedMuted = true;

            self.constaints || (self.constaints = {audio: true, video: false});
            if(self.constaints){
                var audio = !!self.constaints.audio;
                //self.constaints.audio = true;
                self.constaints.video || (self.constaints.video = false);

                self.constaints.video || (self.voff = 1);
                self.constaints.audio || (self.aoff = 1);

                audio === false && (self.aoff = 1);
            }

            emedia.config.maxVideoBitrate && (self.vbitrate = emedia.config.maxVideoBitrate);
            emedia.config.maxAudioBitrate && (self.abitrate = emedia.config.maxAudioBitrate);
        },

        onGotRemoteMediaStream: function(remoteMediaStream){
            var self = this;

            if(!self.remotePlayAudioObject){
                var _audioId = "__o_remote_play_audio_" + self.id;
                var audioObject = document.querySelector("#" + _audioId);
                if(audioObject){
                    //audioObject.remove();
                }else{
                    audioObject = document.createElement("audio");

                    audioObject.style.display = "none";
                    audioObject.id = "__o_remote_play_audio_" + self.id;
                    audioObject.autoplay = true;
                    audioObject.playsinline = true;

                    document.body.appendChild(audioObject);
                }

                //monitorEvents && monitorEvents(audioObject);

                self.remotePlayAudioObject = audioObject;
            }

            // self.remotePlayAudioObject.autoplay = true;
            // self.remotePlayAudioObject.playsinline = true;
            self.remotePlayAudioObject.srcObject = remoteMediaStream;

            //window.__$_remoteMediaStream = remoteMediaStream;
        }
    }),

    //screenOptions ['screen', 'window', 'tab']
    ShareDesktopPubstream: __Stream.extend({
        voff: 0,

        __init__: function () {
            var self = this;

            self.type = 1;
            self._located = true;

            self.mutedMuted = true;
            self.constaints = {audio: !this.aoff, video: true};

            emedia.config.maxVideoBitrate && (self.vbitrate = emedia.config.maxVideoBitrate);
            emedia.config.maxAudioBitrate && (self.abitrate = emedia.config.maxAudioBitrate);
        }
    }),

    __assertCurrent: function () {
        var self = this;
        if(!self.current){
            _logger.error("Please call emedia.service.setup(ticket)");
            throw "Please call emedia.service.setup(ticket)"
        }
        if(self.current.closed){
            _logger.error("current closed");
            throw "current closed"
        }
    },

    hasAudioMixers: function () {
        var self = this;

        self.__assertCurrent();

        for(var sid in self.current.audioMixers) {
            var stream = self.current.audioMixers[sid];
            if(stream && stream.located()){
                return true;
            }
        }
    },

    getMediaDevices: function (kind, devices, errorCallback) {
        if(typeof kind === 'function'){
            errorCallback = devices;
            devices = kind;
            kind = undefined;
        }

        function gotDevices(deviceInfos) {
            var resultDeviceInfos = [];

            for (var i = 0; i !== deviceInfos.length; ++i) {
                var deviceInfo = deviceInfos[i];
                //var deviceId = deviceInfo.deviceId;

                if(!kind){
                    resultDeviceInfos.push(deviceInfo);
                }else if(kind === deviceInfo.kind){
                    resultDeviceInfos.push(deviceInfo);
                }else if (deviceInfo.kind === 'audioinput') {
                } else if (deviceInfo.kind === 'audiooutput') {
                } else if (deviceInfo.kind === 'videoinput') {
                } else {
                    _logger.info('Some other kind of source/device: ', deviceInfo);
                }
            }

            devices && devices(resultDeviceInfos);
        }

        navigator.mediaDevices.enumerateDevices().then(gotDevices).catch(function handleError(error) {
            _logger.warn('navigator.getUserMedia error: ', error);
            errorCallback && errorCallback(error);
        });
    },

    //有些机器必须得getUserMedia后才能够产生正常得cands
    //比如 safair不调用getUserMedia，将不产生cands；window chrome75，则产生得cands中没有ip 而且 uuid.local
    // requireRights: function(success, errorCallback){
    //     function gotDevices(deviceInfos) {
    //         var resultDeviceInfos = [];
    //
    //         for (var i = 0; i !== deviceInfos.length; ++i) {
    //             var deviceInfo = deviceInfos[i];
    //             _logger.info('Got device: ', deviceInfo);
    //         }
    //
    //         success && success(resultDeviceInfos);
    //     }
    //     navigator.mediaDevices.enumerateDevices().then(gotDevices).catch(function handleError(error) {
    //         _logger.warn('navigator.getUserMedia error: ', error);
    //         errorCallback && errorCallback(error);
    //     });
    // },

    // Attach audio output device to video element using device/sink ID.
    // sinkId deviceInfo.deviceId;
    // attachSinkId(videoElement, deviceInfo.deviceId);
    attachSinkId: function (videoObj, sinkId) {
        if (typeof videoObj.sinkId !== 'undefined') {
            videoObj.setSinkId(sinkId)
                .then(function() {
                    _logger.info('Success, audio output device attached: ' + sinkId);
                })
                .catch(function(error) {
                    var errorMessage = error;
                    if (error.name === 'SecurityError') {
                        errorMessage = 'You need to use HTTPS for selecting audio output ' + 'device: ' + error;
                    }
                    _logger.warn(errorMessage);
                });
        } else {
            _logger.warn('Browser does not support output device selection.');
        }
    },

    _stopTracks: function (_stream) {
        emedia.stopTracks(_stream);
        _stream && _logger.warn("Stream tracks stop. it = ", _stream);
    },
    _enableVideoTracks: function (_stream, enabled) {
        emedia.enableVideoTracks(_stream, enabled);
    },
    _enableAudioTracks: function (_stream, enabled) {
        emedia.enableAudioTracks(_stream, enabled);
    },

    /**
     * 手机 前置
     * video:{ 'facingMode': "user" }//调用前置摄像头
     * video: { facingMode: { exact: "environment" } }//后置
     *
     * @param pubS
     * @returns {{then: then}}
     */
    openUserMedia: function (pubS) {
        _logger.debug("begin open user media", pubS);

        var self = this;

        //self.__assertCurrent();

        if(!pubS){
            _logger.error("require pubS");
            throw "require pubS";
        }

        return {
            then: function (_success, errCallback) {
                // stream.oninactive = self._onStreamInactive.bind(self, stream);
                // stream.onactive = self._onStreamActive.bind(self, stream);

                function success() {
                    _success.apply(null, arguments);

                    var mediaStream = pubS.localStream;
                    if(mediaStream){
                        mediaStream.oninactive = self._onStreamInactive.bind(self, pubS, mediaStream);
                        mediaStream.onactive = self._onStreamActive.bind(self, pubS, mediaStream);
                    }
                }

                if(pubS instanceof self.AVPubstream){
                    self._openCamera(pubS, success, errCallback);
                }else if(pubS instanceof self.ShareDesktopPubstream){
                    self._openSharedDesktop(pubS, success, errCallback)
                }else if(pubS instanceof self.AudioMixerPubstream){
                    self._openCamera(pubS, success, errCallback)
                }else{
                    _logger.error("Unspported pubS");
                    throw "Unspported pubS"
                }
            }
        }
    },

    _openSharedDesktop: function (pubS, success, errCallback) {
        var self = this;

        //self.__assertCurrent();

        function getAudioStream(pubS) {
            var audioConstaints = {audio: true};
            if(pubS.constaints){
                if(typeof pubS.constaints.audio === 'object' && pubS.constaints.audio){
                }else if(!pubS.constaints.audio){
                    audioConstaints.audio = false;
                }
            }
            self.__getUserMedia(audioConstaints, function (_user, stream) {
                var mediaStream = new MediaStream();
                mediaStream._located = true;

                stream && stream.getAudioTracks().forEach(function(track) {
                    mediaStream.addTrack(track);
                });

                pubS.localStream && pubS.localStream.getVideoTracks().forEach(function(track) {
                    mediaStream.addTrack(track);
                });

                pubS.localStream = mediaStream;

                success && success(self.current, mediaStream);
            }, errCallback);
        }

        var videoTracks;
        if(pubS._localMediaStream
            && (videoTracks = pubS._localMediaStream.getVideoTracks())
            && videoTracks.length > 0){
            pubS.localStream = pubS._localMediaStream;

            if(pubS.constaints.audio){
                getAudioStream(pubS);
            }else{
                success && success(self.current, stream);
            }

            return ;
        }

        //screenOptions ['screen', 'window', 'tab']
        __desktop.openDesktopMedia(pubS.screenOptions || ['screen', 'window', 'tab'], function (_event) {
            if(_event instanceof __event.OpenDesktopMedia){
                var desktopStreamId = _event.desktopStreamId;
                _logger.warn("desktop streamId", desktopStreamId);

                var constraints = {
                    audio: false,
                    video: {
                        mandatory: _util.extend(pubS.mandatory || {}, {
                            chromeMediaSource: 'desktop',
                            chromeMediaSourceId: desktopStreamId,
                            // maxWidth: window.screen.width > 1920 ? window.screen.width : 1920,
                            // maxHeight: window.screen.height > 1080 ? window.screen.height : 1080
                        }),
                        optional: []
                    }
                };

                //delete pubS.mandatory;

                self.__getUserMedia(constraints, function (_me, stream) {
                    pubS.localStream = stream;

                    if(pubS.constaints.audio){
                        getAudioStream(pubS);
                    }else{
                        success && success(self.current, stream);
                    }
                }, errCallback);
            } else {
                self.current && self.current.onEvent(new __event.ShareDesktopExtensionNotFound({member: self.current}));
                errCallback && errCallback(_event);
            }
        });
    },

    _openCamera: function(pubS, success, errCallback){
        var self = this;
        //self.__assertCurrent();

        //var constaints = pubS.constaints || {audio: !pubS.aoff, video: !pubS.voff};
        var constaints = pubS.constaints || {audio: true, video: true};

        function successCallback (_me, stream) {
            self.__controlStream(pubS, stream);

            pubS.localStream = stream;
            success && success(self.current, stream);
        }
        self.__getUserMedia(constaints, successCallback.bind(constaints), errCallback);
    },

    __controlStream: function (pubS, stream) {
        emedia.enableVideoTracks(stream, !pubS.voff);
        emedia.enableAudioTracks(stream, !pubS.aoff);
    },

    __getUserMedia: function (constaints, success, errCallback) {
        _logger.debug('get user media. using constaints', constaints);

        var self = this;

        constaints = _util.extend({}, constaints);
        // if(typeof constaints.audio === 'object' && constaints.audio){
        //     constaints.audio = true;
        // }

        var _openstream;

        function onFail(e) {
            _logger.debug('[WebRTC-API] getUserMedia() error: ', e);

            emedia.stopTracks(_openstream);

            self.current && self.current.onEvent(new __event.OpenMediaError({member: self.current, event: e}));
            errCallback && errCallback(new __event.OpenMediaError({member: self.current, event: e}));
        }

        function onSuccess(stream){
            if(self.current && !self.current.closed) {
                //push stream时，由于异步，在未返回成功后，退出会议，摄像头不会被关闭问题
                //将stream 与 Attendee绑定
                self.current._openedRtcMediaStreams[stream.id] = stream;
                stream._bindAttendee = self.current;
                stream._bindAttendeeId = self.current.getMemberId();
                _logger.info("stream bind attendee.", stream.id,
                    (self.current.ticket && self.current.ticket.id), self.current.getMemberId(), self.current.memName);
            }

            emedia._yetGetUserMedia = true;

            _openstream = stream;

            var videoTracks = stream.getVideoTracks();
            var audioTracks = stream.getAudioTracks();

            if (videoTracks.length > 0) {
                var videoTrack = videoTracks[0];
                _logger.debug(stream.id, 'using video device: ',
                    videoTrack.id, videoTrack.label, videoTrack.kind, videoTrack.enabled);
            }
            if (audioTracks.length > 0) {
                var audioTrack = audioTracks[0];
                _logger.debug(stream.id, 'using audio device: ',
                    audioTrack.id, audioTrack.label, audioTrack.kind, audioTrack.enabled);
            }

            stream._located = true;

            //window electron 69-73, 当摄像头被占用后，不会抛出任何异常，但是stream active == false
            if(typeof stream.active === "boolean" && !stream.active){
                _logger.error("media stream not active. it is", stream.id);
                onFail({constraint: constaints, name: "NotAllowedStreamNonactive", message: "stream non-active"});
                return;
            }

            // stream.oninactive = self._onStreamInactive.bind(self, stream);
            // stream.onactive = self._onStreamActive.bind(self, stream);

            success && success(self.current, stream);
        }

        self.__sysGetUserMedia(constaints, onSuccess, onFail);
    },

    _onStreamInactive: function(pubS, mediaStream, event){

        var self = this;
        _logger.warn("media stream inactive. it =", mediaStream.id);

        pubS.onMediaInactive && self.current && _util.forEach(self.current._cacheStreams, function (_sid, _stream) {
            if(_stream.located() && _stream.localStream && _stream.localStream.id === mediaStream.id){
                if(!_stream._webrtc || !_stream._webrtc.closed){
                    pubS.onMediaInactive.call(_stream, mediaStream, event, self);
                }
            }
        });
    },
    _onStreamActive: function(pubS, mediaStream, event){
        var self = this;
        _logger.warn("media stream active. it =", mediaStream.id);

        pubS.onMediaActive && self.current && _util.forEach(self.current._cacheStreams, function (_sid, _stream) {
            if(_stream.located() && _stream.localStream && _stream.localStream.id === mediaStream.id){
                pubS.onMediaActive.call(_stream, mediaStream, event, self);
            }
        });
    },

    __sysGetUserMedia: function(constaints, onSuccess, onFail){
        async function getUserMedia(constaints, onSuccess, onFail) {
            if(typeof emedia.config.globalConstraints === 'object'){
                if(typeof emedia.config.globalConstraints.audio === 'object' && constaints.audio){
                    if(typeof constaints.audio === 'boolean'){
                        constaints.audio = _util.extend({}, emedia.config.globalConstraints.audio);
                    }else{
                        constaints.audio = _util.extend({}, emedia.config.globalConstraints.audio, constaints.audio);
                    }
                }
                if(typeof emedia.config.globalConstraints.video === 'object' && constaints.video){
                    if(typeof constaints.video === 'boolean'){
                        constaints.video = _util.extend({}, emedia.config.globalConstraints.video);
                    }else{
                        constaints.video = _util.extend({}, emedia.config.globalConstraints.video, constaints.video);
                    }
                }
            }

            _logger.info("navigator.mediaDevices.getUserMedia constaints = ", JSON.stringify(constaints));



            // audio video 分别获取
            var mediaStream = new MediaStream();
            let audioStream, videoStream;

            if(constaints.audio) {
                try {
                    audioStream = await navigator.mediaDevices.getUserMedia({audio: true})
                } catch (error) {
                    console.error('getUserMedia audio error', error);
                }
            }
            if(constaints.video) {
                try {
                    videoStream = await navigator.mediaDevices.getUserMedia({video: true})
                } catch (error) {
                    console.error('getUserMedia video error', error);
                }
            }

            if(audioStream) {
                audioStream.getAudioTracks().forEach(function(track) {
                    mediaStream.addTrack(track);
                });
            }
            if(videoStream) {
                videoStream.getVideoTracks().forEach(function(track) {
                    mediaStream.addTrack(track);
                });
            }


            if( !audioStream && !videoStream ){
                onFail({ message: 'getUserMedia error: not have input device'})
            } else {
                onSuccess(mediaStream)
            }
        }
        getUserMedia(constaints, onSuccess, onFail);
    },

    attachMediaStream: window.attachMediaStream.bind({logger: _logger}),

    setup: function (ticket, ext) {
        var self = this;

        _logger.count();
        _logger.debug("recv ticket", ticket, ext);
        _logger.debug("use sdk version", window._emediaVersion);
        _logger.debug(navigator.userAgent);

        ext = ext || {};

        var extObj = ext;
        if(_util.isPlainObject(ext)){ //ext 是对象， extObj 也是对象
            ext = JSON.stringify(ext);
        }else{ //ext 是字符串， extObj 尽量转换为 对象
            try{
                extObj = JSON.parse(ext);
            }catch (e){
            }
        }

        if(typeof ticket === "string"){
            ticket = JSON.parse(ticket);
        }

        var sysUserId, memName;
        sysUserId = memName = ticket.memName;
        emedia._lastSetupConfr = ticket.confrId;
        emedia._lastSetupMemName = memName;
        emedia._lastSetupDate = new Date();
        emedia._lastSetupTktId = ticket.tktId;

        if(self.current && !self.current.closed){
            var __eventCalling = new __event.CurrentCalling();
            self.current.onEvent(__eventCalling);

            _logger.error("confr not close. calling...");
            throw __eventCalling;
            //return;

            //self.current.exit(0);
        }

        var TargetAttendee = self.Attendee || Attendee;
        var _Attendee = TargetAttendee.extend(EventHandler);

        var attendee = self.current = new _Attendee({
            _service: self,
            service: self,
            autoSub: emedia.config.autoSub,
            getCopyIntervalMillis: emedia.config.getCopyIntervalMillis,
            sysUserId: sysUserId,
            memName: memName,
            resource: self.resource,
            nickName: self.nickName,
            ticket: ticket,
            ext: ext,
            extObj: extObj,

            sessionFactory: function(){
                return self.newSession(this, ticket);
            }
        }, self.listeners || {});

        return attendee;
    },

    getStreamById: function (streamId) {
        var stream = this.current && this.current._cacheStreams[streamId];
        return stream && _util.extend(false, {}, stream);
    },

    getStreamsByRtcId: function (rtcId) {
        if(!this.current || !this.current._cacheStreams){
            return;
        }

        var streams = [];
        _util.forEach(this.current._cacheStreams, function (sid, _stream) {
            if (_stream.rtcId === rtcId) {
                streams.push(_stream);
            }
        });
        return streams;
    },

    getMemberById: function (memId) {
        var member = this.current && this.current._cacheMembers[memId];
        return member && _util.extend(false, {}, member);
    },

    exit: function (closeMyConfrIfICrtConfr) {
        _logger.warn("User click exit ", closeMyConfrIfICrtConfr);
        this.current && this.current.exit(closeMyConfrIfICrtConfr);
    },

    join: function(joined, joinError){
        _logger.debug("begin join ...");

        var self = this;

        self.__assertCurrent();
        if(self.current._memberId){ //已经加入会议
            _logger.warn("Had joined. igrone it");
            joined && joined(self.memId);
            return;
        }else{
            self.current._session._sessionId = undefined;
        }

        self.current.join(joined, joinError);
    },

    withpublish: function (pubS) {
        var self = this;

        if(!pubS || !pubS.localStream){
            _logger.error("pubS null or stream not open");
            throw "pubS null or stream not open";
        }

        self.__assertCurrent();
        if(self.current._memberId){ //已经加入会议
            _logger.warn("Had joined. igrone it");
        }else{
            self.current._session._sessionId = undefined;
        }

        return self.current.withpublish(pubS);
    },

    push: function(pubS, pushed, onPushError){
        _logger.debug("begin push ...");

        var self = this;

        if(arguments.length === 2){
            onPushError = pushed;
            pushed = undefined;
        }

        if(!pubS || !pubS.localStream){
            _logger.error("pubS or stream open");
            throw "pubS or stream open";
        }

        self.__assertCurrent();
        self.current.push(pubS, pushed, onPushError, false);
    },

    subscribe: function (streamId, onSub, subfail, subArgs) {
        var self = this;

        _logger.info("begin subscribe ", streamId, subArgs);

        if(onSub && _util.isPlainObject(onSub)){
            subArgs = onSub;
            onSub = subfail = undefined;
        }
        if(subfail && _util.isPlainObject(subfail)){
            subArgs = subfail;
            subfail = onSub;
            onSub = undefined;
        }

        if(emedia.isSafari){ // safari 两个流同时订阅可能会出现无声音 等一等
            var sub = {
                streamId: streamId,
                onSub: onSub,
                subfail: subfail,
                subArgs: subArgs
            };

            var subs = (self.__safari_subs || (self.__safari_subs = []));
            subs.push(sub);

            function _onSub(){
                try{
                    var shiftsub = subs.shift();
                    shiftsub && shiftsub.onSub && shiftsub.onSub.apply(shiftsub, arguments);
                }finally{
                    next();
                }
            }
            function _subfail(){
                try{
                    var shiftsub = subs.shift();
                    shiftsub && shiftsub.subfail && shiftsub.subfail.apply(shiftsub, arguments);
                }finally{
                    next();
                }
            }

            function next(){
                if(subs.length > 0){
                    self.__subscribe(subs[0].streamId, _onSub, _subfail, subs[0].subArgs);
                }
            }

            if(subs.length === 1){
                next();
            }
        }else{
            self.__subscribe(streamId, onSub, subfail, subArgs);
        }
    },
    __subscribe: function (streamId, onSub, subfail, subArgs) {
        var self = this;

        self.__assertCurrent();

        if(arguments.length == 2){
            subfail = onSub;
            onSub = undefined;
        }

        if(onSub && _util.isPlainObject(onSub)){
            subArgs = onSub;
            onSub = undefined;
        }
        if(subfail && _util.isPlainObject(subfail)){
            subArgs = subfail;
            subfail = undefined;
        }

        subArgs || (subArgs = {subSVideo: true, subSAudio: true});


        var subStream = self.current._cacheStreams[streamId];
        // if(subStream && subStream.type === 2 && subArgs.subSAudio !== undefined && !subArgs.subSAudio){
        //     subfail && subfail(new __event.AudioMixerStreamNotAllowOnlySubVideo({stream: subStream}));
        //     self.current.onEvent(new __event.AudioMixerStreamNotAllowOnlySubVideo({stream: subStream}));
        //     return;
        // }

        var webrtc = self.current._getWebrtc(streamId);

        var usePreRTCPeer = webrtc && webrtc.isConnected();

        var remoteStream = usePreRTCPeer && webrtc.getRemoteStream();
        if(remoteStream
            && (usePreRTCPeer = remoteStream.active)){
            var hasAudioTracks = remoteStream.getAudioTracks().length;
            var hasVideoTracks = remoteStream.getVideoTracks().length;

            if(!hasAudioTracks && subArgs.subSAudio === true){
                usePreRTCPeer = false
            }else if(!hasVideoTracks && subArgs.subSVideo === true){
                usePreRTCPeer = false
            }
        }

        _logger.info("sub stream", streamId, ", use prertcpeer =", usePreRTCPeer);

        if(usePreRTCPeer){
            self.current.subscribeStream(webrtc._rtcId, streamId, subfail, subArgs, onSub);
            onSub && onSub();
            return;
        }

        webrtc && (!webrtc.closed) && self.current.closeWebrtc(webrtc.getRtcId(), true, false);

        self.current.createWebrtcAndSubscribeStream(streamId, {
            onGotRemote: function(stream) {
                onSub && onSub(stream)
            },
            onEvent: function(_evt){
                subfail && subfail(_evt)
            }
        }, undefined, subArgs);
    },

    closePubstream: function (stream) {
        if(stream.located()){
            emedia.stopTracks(stream._localMediaStream);
            emedia.stopTracks(stream.localStream);
        }
    },

    hungup: function (streamId) {
        var stream = this.getStreamById(streamId);

        try{
            this._hungup(streamId);
        }finally{
            this.onHungup && stream && this.onHungup(stream);
        }
    },
    _hungup: function (streamId) {
        var self = this;

        self.__assertCurrent();

        var attendee = self.current;

        var stream = attendee._cacheStreams[streamId];
        stream && !stream.closeReason && stream.updateAttributes({
            closeReason: 'UserHangup'
        });

        var rtcId = stream && stream.rtcId;
        if(rtcId){
            attendee.closeWebrtc(rtcId);

            if(stream.located()){
                stream.type !== 1 && stream._localMediaStream && emedia.stopTracks(stream._localMediaStream);

                if(stream.remotePlayAudioObject){
                    document.body.removeChild(stream.remotePlayAudioObject);
                }

                attendee._cacheStreams[streamId] && attendee.onRemoveStream(stream);

                _util.removeAttribute(attendee._cacheStreams, streamId);
                self._streamAutomators && _util.removeAttribute(self._streamAutomators, streamId);
            }
        }

        if(stream && !stream.located()){
            attendee._linkedStreams[stream.id] && (_util.removeAttribute(attendee._linkedStreams, stream.id));
            _logger.warn("Hangeup remove from _linkedStreams. stream = ", stream.id);

            stream = attendee._cacheStreams[streamId];
            if(!stream){
                return;
            }

            stream.updateAttributes({
                rtcId: undefined,
                _webrtc: undefined,
                mediaStream: undefined
            });

            var _stream = new __Stream(stream);
            attendee.onUpdateStream(_stream, new _stream.Update(_stream));
        }
    },

    postMessage: function (memberIdOrStreamId, message, fail, onRsp) {
        var self = this;

        var theMessage = message;
        if(typeof message !== 'string'){
            message = JSON.stringify(message);
        }

        self.__assertCurrent();
        var attendee = self.current;

        var memberId;

        var linkedStream = attendee._linkedStreams[memberIdOrStreamId];
        if(linkedStream && linkedStream.owner){
            memberId = linkedStream.owner.id;
        }else{
            memberId = memberIdOrStreamId;
        }

        var message = attendee.newMessage({
            op: 1003,
            memId: memberId,
            arg: message
        });

        attendee.postMessage(message, (fail || onRsp) && function (rsp) {
            onRsp && onRsp(rsp, theMessage);

            if(rsp.result != 0){
                var _evt = new __event.RemoteControlFail({memId: memberId, failed: rsp.result, cause: rsp.msg, type: "postMessage", postMessage: message});
                attendee.onEvent(_evt);

                fail && fail(_evt, theMessage);

                return;
            }
        });
    },

    torchRemote: function (streamId, torch, success, fail) {
        var self = this;

        if(typeof torch === 'function'){
            fail = success;
            success = torch;
            torch = undefined;
        }

        if(torch !== undefined){
            torch = torch ? 1 : 0;
        }

        self.__assertCurrent();
        var attendee = self.current;

        var linkedStream = attendee._linkedStreams[streamId];
        if(!linkedStream || linkedStream.located()){
            _logger.error("not exsits or locate, not connect", streamId);
            throw streamId + " not exsits or locate, not connect";
        }

        var lastTorch = linkedStream.torch;
        var torch = (torch === undefined) ? (!linkedStream.torch ? 1 : 0) : torch;

        var arg = {
            op2: 20,
            streamId: streamId,
            tor: torch,
        };

        var message = attendee.newMessage({
            op: 1002,
            memId: linkedStream.owner.id,
            arg: JSON.stringify(arg),
            _reqOps:[100206]
        });

        linkedStream.updateAttributes({torch: torch});

        attendee.postMessage(message, function (rsp) {
            if(rsp.result != 0){
                var _evt = new __event.RemoteControlFail({stream: linkedStream, failed: rsp.result, cause: rsp.msg, type: "torch_control"});
                attendee.onEvent(_evt);

                linkedStream.updateAttributes({torch: lastTorch});

                fail && fail(_evt, linkedStream.torch);

                return;
            } else {
                success && success(linkedStream.torch);
            }
        });
    },

    freezeFrameRemote: function (streamId, success, fail) {
        var self = this;

        self.__assertCurrent();
        var attendee = self.current;

        var linkedStream = attendee._linkedStreams[streamId];
        if(!linkedStream || linkedStream.located()){
            _logger.error("not exsits or locate, not connect", streamId);
            throw streamId + " not exsits or locate, not connect";
        }

        var freezeFrame = !linkedStream.freezeFrame;

        var arg = {
            op2: 20,
            streamId: streamId,
            frz: (freezeFrame ? 1 : 0),
        };

        var message = attendee.newMessage({
            op: 1002,
            memId: linkedStream.owner.id,
            arg: JSON.stringify(arg),
            _reqOps:[100204]
        });

        linkedStream.updateAttributes({freezeFrame: freezeFrame});

        attendee.postMessage(message, function (rsp) {
            if(rsp.result != 0){
                var _evt = new __event.RemoteControlFail({stream: linkedStream, failed: rsp.result, cause: rsp.msg, type: "freeze_control"});
                attendee.onEvent(_evt);

                linkedStream.updateAttributes({freezeFrame: !linkedStream.freezeFrame});

                fail && fail(_evt, linkedStream.freezeFrame);

                return;
            } else {
                success && success(linkedStream.freezeFrame);
            }
        });
    },

    base64Img2Blob: function base64Img2Blob(code) {
        var parts = code.split(';base64,');
        var contentType = parts[0].split(':')[1];
        var raw = window.atob(parts[1]);
        var rawLength = raw.length;

        var uInt8Array = new Uint8Array(rawLength);

        for (var i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }

        // if(emedia.isSafari){
        //     return new Blob([uInt8Array], {type:"application/octet-stream"});
        // }

        return new Blob([uInt8Array], {type: contentType});
    },

    blob2URL: function (blob) {
        return URL.createObjectURL(blob);
    },

    imagesPngContext2URL: function (code) {
        var self = this;
        return self.blob2URL(self.blob2URL(code));
    },

    downloadFile: function downloadFile(fileName, content, blobs) {
        var self = this;

        var aLink = document.createElement('a');
        aLink.style.display = 'none';
        var blob = content ? self.base64Img2Blob(content) : blobs; //new Blob([content]);

        // if(typeof FileReader === 'object'){
        //     var reader = new FileReader();
        //
        //     reader.onloadend = function () {
        //         var url = reader.result;
        //         url = url.replace(/^data:[^;]*;/, 'data:attachment/file;');
        //         window.location.href = url;
        //     };
        //
        //     reader.readAsDataURL(blob);
        //     return;
        // }

        var blobUrl;
        aLink.download = fileName;
        aLink.href = blobUrl = self.blob2URL(blob);
        aLink.rel = 'noopener';

        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", false, false); //initEvent 不加后两个参数在FF下会报错
        aLink.dispatchEvent(evt);

        document.body.appendChild(aLink);
        aLink.click();
        aLink.parentNode.removeChild(aLink);

        setTimeout(function () {
            URL.revokeObjectURL && URL.revokeObjectURL(blobUrl);
        }, 40000);
    },

    videoCaptureBase64Context2URL: function (videoObj) {
        var self = this;
        return self.imagesPngContext2URL(self.getCaptureBase64Context(videoObj));
    },

    getCaptureBase64Context: function (videoObj) {
        var canvas = document.createElement("canvas");
        var id = canvas.id = "__capture_video_" + new Date().getTime();

        canvas.width = videoObj.videoWidth;
        canvas.height = videoObj.videoHeight;

        var canvas2dContext = canvas.getContext('2d');
        canvas2dContext.drawImage(videoObj, 0, 0, canvas.width, canvas.height);

        var base64 = canvas.toDataURL('images/png');
        //console.log(base64);

        return base64;
    },

    captureVideo: function captureVideo(videoObj, storeLocal, filename) {
        var self = this;

        var base64 = self.getCaptureBase64Context(videoObj);

        if (storeLocal) {
            filename = filename || ("capture_" + (new Date()).getTime());
            self.downloadFile(filename, base64);
            //window.location.href = base64;

            // var iframe = document.createElement("iframe");
            // iframe.id = "__capture_video_pic_dl_iframe_" + (new Date().getTime());
            // iframe.style.display = "none";
            //
            // //document.body.appendChild(iframe);
            //
            // iframe.src = base64;
            // //iframe.contentWindow.location.href = URL.createObjectURL(base64);
            //
            // setTimeout(function () {
            //     //document.body.removeChild(iframe);
            // }, 50);
        }

        return base64;
    },

    capturePictureRemote: function (streamId, rspBase64Pic, success, fail) {
        var self = this;

        self.__assertCurrent();
        var attendee = self.current;

        var linkedStream = attendee._linkedStreams[streamId];
        if(!linkedStream || linkedStream.located()){
            _logger.error("not exsits or locate, not connect", streamId);
            throw streamId + " not exsits or locate, not connect";
        }

        var arg = {
            op2: 20,
            streamId: streamId,
            pic: 1,
            rspBase64Pic: (rspBase64Pic === true)
        };

        var message = attendee.newMessage({
            op: 1002,
            memId: linkedStream.owner.id,
            arg: JSON.stringify(arg),
            _reqOps:[100205]
        });

        attendee.postMessage(message, function (rsp) {
            if(rsp.result != 0){
                var _evt = new __event.RemoteControlFail({stream: linkedStream, failed: rsp.result, cause: rsp.msg, type: "capture_control"});
                attendee.onEvent(_evt);
                fail && fail(_evt);

                return;
            } else {
                if(!rspBase64Pic){
                    success && success();
                    return;
                }

                if(!rsp.arg) {
                    fail && fail(new __event.RemoteControlFail({stream: linkedStream, failed: rsp.result, cause: "Not found base64 pic"}));
                    return;
                }

                var arg = JSON.parse(rsp.arg);
                success && success(arg.pic);
            }
        });
    },

    zoomRemote: function (streamId, multiples, fail, success) {
        var self = this;

        self.__assertCurrent();
        var attendee = self.current;

        var linkedStream = attendee._linkedStreams[streamId];
        if(!linkedStream || linkedStream.located()){
            _logger.error("not exsits or locate, not connect", streamId);
            throw streamId + " not exsits or locate, not connect";
        }

        linkedStream._zoom || (linkedStream.updateAttributes({_zoom: 1}));

        var _zoom = linkedStream._zoom * multiples;
        if(_zoom < 1){
            return;
        }

        linkedStream.updateAttributes({_zoom: _zoom});

        var arg = {
            op2: 20,
            streamId: streamId,
            zoom: Math.round(_zoom * 10000)
        }

        var message = attendee.newMessage({
            op: 1002,
            memId: linkedStream.owner.id,
            arg: JSON.stringify(arg),
            _reqOps:[100201]
        });

        attendee.postMessage(message, function (rsp) {
            if(rsp.result != 0){
                var _evt = new __event.RemoteControlFail({stream: linkedStream, failed: rsp.result, cause: rsp.msg, type: "zoom_control"});
                attendee.onEvent(_evt);
                fail && fail(_evt);

                return;
            }

            success && success();
        });
    },

    _getPosition: function getPosition(obj){
        var topValue= 0,leftValue= 0;
        while(obj){
            leftValue+= obj.offsetLeft;
            topValue+= obj.offsetTop;
            obj= obj.offsetParent;
        }

        return {clientX: leftValue, clientY: topValue};
    },

    eventXYAtMedia: function (eventXY, videoTag) {
        var videoXY = _util.getDomPageRect(videoTag);

        var videoWidth = videoXY.width, videoHeight = videoXY.height;
        var mediaWidth = videoTag.videoWidth, mediaHeight = videoTag.videoHeight;

        if(mediaHeight/mediaWidth > videoHeight/videoWidth){
            var t = mediaWidth / mediaHeight;
            mediaHeight = videoHeight;
            mediaWidth = mediaHeight * t;
        } else {
            var t = mediaHeight / mediaWidth;
            mediaWidth = videoWidth;
            mediaHeight = mediaWidth * t;
        }

        var clickXY = eventXY;

        var isRadioX, isRadioY;
        if(isRadioX = _util.isFloat(clickXY.x)){ //比率
            clickXY.x = clickXY.x * videoWidth;
        }
        if(isRadioY = _util.isFloat(clickXY.y)){ //比率
            clickXY.y = clickXY.y * videoHeight;
        }

        if(Math.abs(clickXY.x) < (videoWidth - mediaWidth) / 2
            || (videoWidth - Math.abs(clickXY.x)  < (videoWidth - mediaWidth) / 2)){
            return;
        }
        if(Math.abs(clickXY.y) < (videoHeight - mediaHeight) / 2
            || (videoHeight - Math.abs(clickXY.y)  < (videoHeight - mediaHeight) / 2)){
            return;
        }

        clickXY.x = clickXY.x < 0 ? Math.floor(clickXY.x + (videoWidth - mediaWidth) / 2)
            : Math.floor(clickXY.x - (videoWidth - mediaWidth) / 2);
        clickXY.y = clickXY.y < 0 ? Math.floor(clickXY.y + (videoHeight - mediaHeight) / 2)
            : Math.floor(clickXY.y - (videoHeight - mediaHeight) / 2);


        if(isRadioX){
            clickXY.x = clickXY.x / mediaWidth;
        }
        if(isRadioY){
            clickXY.y = clickXY.y / mediaHeight;
        }

        return {x: clickXY.x, y: clickXY.y, width: mediaWidth, height: mediaHeight};
    },

    eventXYAtVideo: function (mediaXY, videoTag) {
        var videoXY = _util.getDomPageRect(videoTag);

        var videoWidth = videoXY.width, videoHeight = videoXY.height;
        var mediaWidth = videoTag.videoWidth, mediaHeight = videoTag.videoHeight;

        if(mediaHeight/mediaWidth > videoHeight/videoWidth){
            var t = mediaWidth / mediaHeight;
            mediaHeight = videoHeight;
            mediaWidth = mediaHeight * t;
        } else {
            var t = mediaHeight / mediaWidth;
            mediaWidth = videoWidth;
            mediaHeight = mediaWidth * t;
        }

        var isRadioX, isRadioY;
        if(isRadioX = _util.isFloat(mediaXY.x)){ //比率
            mediaXY.x = mediaXY.x * mediaWidth;
        }
        if(isRadioY = _util.isFloat(mediaXY.y)){ //比率
            mediaXY.y = mediaXY.y * mediaHeight;
        }

        mediaXY.x = mediaXY.x < 0 ? Math.floor(mediaXY.x - (videoWidth - mediaWidth) / 2)
            : Math.floor(mediaXY.x + (videoWidth - mediaWidth) / 2);
        mediaXY.y = mediaXY.y < 0 ? Math.floor(mediaXY.y - (videoHeight - mediaHeight) / 2)
            : Math.floor(mediaXY.y + (videoHeight - mediaHeight) / 2);

        if(isRadioX){
            mediaXY.x = mediaXY.x / videoWidth;
        }
        if(isRadioY){
            mediaXY.y = mediaXY.y / videoHeight;
        }

        return mediaXY;
    },

    getClickXY: function (videoTag, clickEvent) {
        var self = this;

        var e = clickEvent || window.event;
        var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
        var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
        var x = e.pageX || e.clientX + scrollX;
        var y = e.pageY || e.clientY + scrollY;

        var xy = self._getPosition(videoTag);

        _logger.info("Video tag position ", xy.clientX, ":", xy.clientY);


        var mediaWidth = videoTag.videoWidth;
        var mediaHeight = videoTag.videoHeight;

        if(mediaHeight/mediaWidth > videoTag.offsetHeight/videoTag.offsetWidth){
            var t = mediaWidth / mediaHeight;
            mediaHeight = videoTag.offsetHeight;
            mediaWidth = mediaHeight * t;

            xy.clientX += (videoTag.offsetWidth - mediaWidth) / 2;
        } else {
            var t = mediaHeight / mediaWidth;
            mediaWidth = videoTag.offsetWidth;
            mediaHeight = mediaWidth * t;

            xy.clientY += (videoTag.offsetHeight - mediaHeight) / 2;
        }
        _logger.info("Media position ", xy.clientX, ":", xy.clientY);
        _logger.info("Media xy ", mediaWidth, ":", mediaHeight);
        _logger.info("Click position ", x, ":", y);

        return {
            mediaWidth: mediaWidth,
            mediaHeight: mediaHeight,
            x: (x - xy.clientX),
            y: (y - xy.clientY)
        };
    },

    focusExpoRemote: function (streamId, videoTag, clickEvent, fail, success) {
        var self = this;

        var e = clickEvent || window.event;
        var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
        var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
        var x = e.pageX || e.clientX + scrollX;
        var y = e.pageY || e.clientY + scrollY;

        var xy = self._getPosition(videoTag);

        _logger.info("Video tag position ", xy.clientX, ":", xy.clientY);


        var mediaWidth = videoTag.videoWidth;
        var mediaHeight = videoTag.videoHeight;

        if(mediaHeight/mediaWidth > videoTag.offsetHeight/videoTag.offsetWidth){
            var t = mediaWidth / mediaHeight;
            mediaHeight = videoTag.offsetHeight;
            mediaWidth = mediaHeight * t;

            xy.clientX += (videoTag.offsetWidth - mediaWidth) / 2;
        } else {
            var t = mediaHeight / mediaWidth;
            mediaWidth = videoTag.offsetWidth;
            mediaHeight = mediaWidth * t;

            xy.clientY += (videoTag.offsetHeight - mediaHeight) / 2;
        }
        _logger.info("Media position ", xy.clientX, ":", xy.clientY);
        _logger.info("Media xy ", mediaWidth, ":", mediaHeight);
        _logger.info("Click position ", x, ":", y);

        self._focusExpo(streamId, mediaWidth, mediaHeight, (x - xy.clientX), (y - xy.clientY), fail, success);
    },

    _focusExpo: function (streamId, width, height, x, y, fail, success) {
        var self = this;

        if(x <= 0 || x > width){
            return;
        }
        if(y <= 0 || y > height){
            return;
        }

        self.__assertCurrent();
        var attendee = self.current;

        var linkedStream = attendee._linkedStreams[streamId];
        if(!linkedStream || linkedStream.located()){
            _logger.error("not exsits or locate, not connect", streamId);
            throw streamId + " not exsits or locate, not connect";
        }

        var arg = {
            op2: 20,
            streamId: streamId,
            focus: 1,
            expo: 1,
            x: width === 0 ? 0 : Math.round(x * 10000 / width),
            y: height === 0 ? 0 : Math.round(y * 10000 / height)
        }

        var message = attendee.newMessage({
            op: 1002,
            memId: linkedStream.owner.id,
            arg: JSON.stringify(arg),
            _reqOps:[100202, 100203]
        });

        attendee.postMessage(message, function (rsp) {
            if(rsp.result != 0){
                var _evt = new __event.RemoteControlFail({stream: linkedStream, failed: rsp.result, cause: rsp.msg, type: "focus_expo_control"});
                attendee.onEvent(_evt);
                fail && fail(_evt);

                return;
            }else{
                success && success();
            }
        });
    },

    _republish: function (pubS, success, error) {
        _logger.info("Republish stream. it = ", pubS.id);

        var self = this;

        var webrtc;
        if(pubS.id){
            var rtcId = self.current.__getWebrtcFor(pubS.id);
            rtcId && self.current.closeWebrtc(rtcId, true);

            webrtc = self.current._getWebrtc(pubS.id);
        }

        var _pubS;

        // if(emedia.isSafari){
        //     emedia.enableAudioTracks(false);
        //     emedia.enableVideoTracks(false);
        // }

        switch(pubS.type) {
            case 0:
                //emedia.isSafari || emedia.stopTracks(pubS._localMediaStream);
                emedia.stopTracks(pubS._localMediaStream);
                _pubS = new self.AVPubstream(pubS);

                break;
            case 1:
                //emedia.isSafari || emedia.stopAndRemoveAudioTracks(pubS._localMediaStream);
                emedia.stopAndRemoveAudioTracks(pubS._localMediaStream);
                _pubS = new self.ShareDesktopPubstream(pubS);

                break;
            case 2:
                //emedia.isSafari || emedia.stopTracks(pubS._localMediaStream);
                emedia.stopTracks(pubS._localMediaStream);
                _pubS = new self.AudioMixerPubstream(pubS);

                break;
        }

        setTimeout(function () {
            self.openUserMedia(_pubS).then(function () {
                pubS.localStream = _pubS.localStream;

                pubS.isRepublished = true;

                pubS.optimalVideoCodecs = pubS.optimalVideoCodecs || ( webrtc && webrtc.optimalVideoCodecs);
                self.push(pubS, success, error);
            }, error);
        }, 100);

        // if(emedia.isSafari){
        //     setTimeout(function () {
        //         switch(pubS.type) {
        //             case 0:
        //                 emedia.stopTracks(pubS._localMediaStream);
        //                 break;
        //             case 1:
        //                 emedia.stopAndRemoveAudioTracks(pubS._localMediaStream);
        //                 break;
        //             case 2:
        //                 emedia.stopTracks(pubS._localMediaStream);
        //                 break;
        //         }
        //     }, 1400);
        // }
    },

    switchMobileCamera: function(pubS, error, success){
        var self = this;

        if(typeof pubS === 'string'){ //id
            pubS = self.current._cacheStreams[pubS];
        } else if(pubS.id){
            pubS = self.current._cacheStreams[pubS.id];
        }

        if(pubS.voff){
            _logger.warn("Stream id = ", pubS.id, " voff, do not chanage camera.");
            return;
        }

        pubS.constaints || (pubS.constaints = {});
        var preConstaints = _util.extend({}, pubS.constaints);
        pubS._lastConstaints = preConstaints;

        //video: {'facingMode': "user"}, // 前置
        //video: { facingMode: { exact: "environment" } } //后置
        pubS.constaints.video = (typeof pubS.constaints.video === "object") ? pubS.constaints.video : {};
        if(pubS.constaints.video.facingMode === "user" || !pubS.constaints.video.facingMode){ //facingMode不存在或指定了user当前置
            pubS.constaints.video.facingMode = {exact: "environment"};
        }else{ //pubS.constaints.video.facingMode
            pubS.constaints.video.facingMode = "user";
        }

        self._republish(pubS, function(mediaStream){
            success && success(mediaStream);
        },function (_evt) {
            if(_evt instanceof emedia.event.OpenMediaError){ //设备可能不支持，比如 没有摄像头，或 被禁止访问摄像头
                pubS.constaints = preConstaints;
            }

            error && error(_evt);
        });
    },

    chanageCamera: function(pubS, error, success){
        var self = this;

        if(typeof pubS === 'string'){ //id
            pubS = self.current._cacheStreams[pubS];
        } else if(pubS.id){
            pubS = self.current._cacheStreams[pubS.id];
        }

        if(pubS.voff){
            _logger.warn("Stream id = ", pubS.id, " voff, do not chanage camera.");
            return;
        }

        self.getMediaDevices("videoinput", function (devices) {
            if(devices.length <= 1){
                _logger.warn("Only video input. not chanage");
                return;
            }

            var cameraIndex = pubS._cameraIndex;

            if(pubS._cameraIndex === null || pubS._cameraIndex === undefined){
                var localStream = pubS.getLocalMediaStream();
                var videoTracks = localStream && localStream.getVideoTracks();
                var track = videoTracks && videoTracks.length && videoTracks[0];

                if(track && track.getCapabilities && typeof track.getCapabilities === 'function'){
                    var videoCapabilities = track.getCapabilities();
                    var deviceId = videoCapabilities && videoCapabilities.deviceId;

                    for(var index in devices){
                        var device = devices[index];
                        if(device.deviceId === deviceId
                            || device.label == track.label){
                            cameraIndex = parseInt(index);
                            break;
                        }
                    }
                }else{
                    for(var index in devices){
                        var device = devices[index];
                        if(device.label == track.label){
                            cameraIndex = parseInt(index);
                            break;
                        }
                    }
                }
            }

            while(cameraIndex < devices.length){
                var lastDevice = devices[cameraIndex];
                cameraIndex = (cameraIndex + 1) % devices.length;

                var device = devices[cameraIndex];

                var videoTracks = pubS.getLocalMediaStream().getVideoTracks();
                if(!videoTracks || videoTracks.length === 0 || device.label != videoTracks[0].label){
                    break;
                }
            }

            var device = devices[cameraIndex];
            var deviceInfoLabel = device.label;

            _logger.warn("Stream ", pubS.id, lastDevice.label, ">>", deviceInfoLabel);

            pubS._cameraIndex = cameraIndex;

            pubS.constaints || (pubS.constaints = {});
            var preConstaints = _util.extend({}, pubS.constaints);
            pubS._lastConstaints = preConstaints;

            pubS.constaints.video = (typeof pubS.constaints.video === "object") ? pubS.constaints.video : {};
            pubS.constaints.video.deviceId = {exact: device.deviceId};

            self._republish(pubS, function(mediaStream){
                success && success(mediaStream);
            },function (_evt) {
                if(_evt instanceof emedia.event.OpenMediaError){ //设备可能不支持，比如 没有摄像头，或 被禁止访问摄像头
                    pubS.constaints = preConstaints;
                }

                error && error(_evt);
            });
        }, error);
    },

    chanageConstraints: function(pubS, constraints, error, success){
        var self = this;

        if(typeof pubS === 'string'){ //id
            pubS = self.current._cacheStreams[pubS];
        } else if(pubS.id){
            pubS = self.current._cacheStreams[pubS.id];
        }

        if(!pubS){
            _logger.warn("Not found pubS");
            return;
        }
        _logger.info("chanage pubstream constraints. it", pubS.id, constraints);

        function updateAndDisabled() {
            var mediaStream = pubS.getMediaStream();
            emedia.enableVideoTracks(mediaStream, !pubS.voff);
            emedia.enableAudioTracks(mediaStream, !pubS.aoff);
        }

        if(_.isObject(constraints) && !_.isEqual(pubS.constaints, constraints)){
            var preConstraints = pubS.constaints || {};
            var preVoff = pubS.voff;
            var preAoff = pubS.aoff;

            pubS._lastConstaints = preConstraints;
            pubS.constaints = _util.extend(true, {}, preConstraints, constraints);

            pubS.aoff = pubS.constaints.audio ? 0 : 1;
            pubS.voff = pubS.constaints.video ? 0 : 1;

            self._republish(pubS, function(mediaStream){
                updateAndDisabled();
                success && success(mediaStream);
            },function (_evt) {
                if(_evt instanceof emedia.event.OpenMediaError){ //设备可能不支持，比如 没有摄像头，或 被禁止访问摄像头
                    pubS.constaints = preConstraints;
                    pubS.aoff = preAoff;
                    pubS.voff = preVoff;
                }

                error && error(_evt);
            });

            return;
        }

        updateAndDisabled();
        success && success(pubS.getMediaStream());
    },

    voff: function(pubS, _voff, error, success){
        var self = this;

        if(typeof pubS === 'string'){ //id
            pubS = self.current._cacheStreams[pubS];
        }

        var oldVoff = pubS.voff;
        _voff = _voff ? 1 : 0;
        pubS.voff = _voff;

        function updateAndDisabled() {
            if(_voff == oldVoff){
                _logger.info("pubstream voff not chanage.");
                return;
            }
            emedia.enableVideoTracks(pubS.getMediaStream(), !_voff);
            self.current && self.current.voff(pubS, _voff);
        }

        if(!_voff && pubS.constaints && !pubS.constaints.video){
            //error && error("When pub. only audio, voff invalidate");
            //throw "When pub. only audio, voff invalidate";

            var preVideo = pubS.constaints.video;

            pubS.constaints.video = true;
            self._republish(pubS, function(mediaStream){
                updateAndDisabled();
                success && success(mediaStream);
            },function (_evt) {
                if(_evt instanceof emedia.event.OpenMediaError){ //设备可能不支持，比如 没有摄像头，或 被禁止访问摄像头
                    pubS.constaints.video = preVideo;
                    pubS.voff = oldVoff;
                }

                error && error(_evt);
            });

            return;
        }

        updateAndDisabled();
        success && success(pubS.getMediaStream());
    },

    aoff: function(pubS, _aoff, error, success){
        var self = this;

        if(typeof pubS === 'string'){ //id
            pubS = self.current._cacheStreams[pubS];
        }

        var oldAoff = pubS.aoff;
        _aoff = _aoff ? 1 : 0;
        pubS.aoff = _aoff;

        function updateAndDisabled() {
            if(_aoff == oldAoff){
                _logger.info("pubstream aoff not chanage.");
                return;
            }

            emedia.enableAudioTracks(pubS.getMediaStream(), !_aoff);
            self.current && self.current.aoff(pubS, _aoff);
        }

        if(!_aoff && pubS.constaints && !pubS.constaints.audio){
            // error && error("When pub. only video, aoff invalidate");
            // throw "When pub. only video, aoff invalidate";

            var preAudio = pubS.constaints.audio;

            pubS.constaints.audio = true;
            self._republish(pubS, function(mediaStream){
                updateAndDisabled();
                success && success(mediaStream);
            },function (_evt) {
                if(_evt instanceof emedia.event.OpenMediaError){ //设备可能不支持，比如 没有摄像头，或 被禁止访问摄像头
                    pubS.constaints.audio = preAudio;
                    pubS.aoff = oldAoff;
                }

                error && error(_evt);
            });

            return;
        }

        updateAndDisabled();
        success && success(pubS.getMediaStream());
    },

    iceing: function (streamId) {
        var self = this;

        return _util.isPlainObject(self.current._linkedStreams[streamId]);
    },

    recording: function (streamId) {
        var self = this;

        return _util.isPlainObject(self.current._records[streamId]);
    },

    startRecord: function (streamId, callback) {
        var self = this;

        var _stream = self.current._linkedStreams[streamId];
        if(!_stream){
            _logger.error("not at linked streams", streamId);
            throw streamId + " not at linked streams";
        }
        if(!_stream._webrtc){
            callback && callback(false);
        }

        self.current.startRecord(_stream, callback);
    },

    stopRecord: function (streamId, callback) {
        var self = this;

        var _stream = self.current._records[streamId];
        if(!_stream){
            _logger.error("not at recording streams", streamId);
            throw streamId + " not at recording streams";
        }

        self.current.stopRecord(_stream, callback);
    },

    getCurrentMembers: function () {
        var self = this;
        return self.current.getCurrentMembers();
    },

    _onCapturePicture: function (evt) {
        var self = this;

        var rspBase64Pic = evt.arg.rspBase64Pic;
        var streamId = evt.arg.streamId;
        var stream = self.current._cacheStreams[streamId];

        var base64;
        if(rspBase64Pic){
            var htmlVideo;
            if(typeof self.getHTMLVideo !== "function" || !(htmlVideo = self.getHTMLVideo(streamId))){
                _logger.warn("Not support capture picture. caused by htmlVideo not found");
                return;
            }

            base64 = self.getCaptureBase64Context(htmlVideo);
        }else{
            if(typeof self.onCapturePicture !== "function"){
                _logger.warn("Not support capture picture. caused by onCapturePicture not found");
                return;
            }
            self.onCapturePicture(stream);
        }

        var message = self.current.newMessage({
            op: 1001,
            tsxId: evt.tsxId,
            memId: evt.memId,
            arg: JSON.stringify(base64 ? {pic: base64} : {}),
            result: 0
        });

        self.current.postMessage(message, function (rsp) {
            _logger.warn("Send remote control onCapturePicture response. the result = ", rsp.result, rsp.msg || "");
        });

        return true;
    },

    // _onRemotePannelControl: function (evt) {
    //
    // },

    newSession: function (attendee, ticket) {
        var self = this;

        var ExtendSession = self.Session || Session;
        var session = new ExtendSession({
            ticket: ticket,
            owner: attendee,

            onTcklC: function(evt){
                attendee.onTcklC(evt.rtcId, evt.cands);
            },
            onAcptC: function(evt){
                attendee.onAcptC(evt.rtcId, evt.sdp, evt.cands);
            },
            onAnsC: function(evt){
                attendee.onAnsC(evt.rtcId, evt.sdp, evt.cands);
            },
            onTermC: function(evt){
                //self.onTermC(me, evt);
                _logger.info("Server termc rtc: ", evt.rtcId, evt.message || evt.msg);

                let { endReason } = evt;
                if(endReason === 21 || endReason === 22){ 
                    _util.forEach(attendee._cacheStreams, function (sid, _stream) {
                        if(_stream.rtcId === evt.rtcId){
                            var _event;
                            if(endReason === 21){ // 建议更换编码方式
                                _event = new emedia.event.SwitchVCodes({stream: _stream, useVCodes: evt.useVCodes});
                            }else{
                                _event = new emedia.event.SubFailNotSupportVCodes({stream: _stream});
                            }

                            attendee.onEvent(_event);
                        }
                    });
                }else if(endReason == 23) { //达到最大视频数
                    let onCallBack = self.listeners.mgr.onPubVideoTooMuch;
                    if(
                        !onCallBack || 
                        typeof onCallBack != 'function'
                    ) {
                        return
                    }
    
                    onCallBack();
                } else if(endReason == 24) { //达到最大共享桌面数
                    let onCallBack = self.listeners.mgr.onPubDesktopTooMuch;
                    if(
                        !onCallBack || 
                        typeof onCallBack != 'function'
                    ) {
                        return
                    }
    
                    onCallBack()
                } else{
                    attendee.closeWebrtc(evt.rtcId, false, true);
                }
            },
            onEnter: function(evt){
                attendee.onEnter(evt.cver, evt.mem);
            },
            onExit: function(evt){
                attendee.onExit(evt.cver, evt.memId, evt.reason || 0);
            },
            onPub: function(evt){
                attendee.onPub(evt.cver, evt.memId, evt.pubS);
            },
            onUnpub: function(evt){
                attendee.onUnpub(evt.cver, evt.memId, evt.pubSId);
            },
            onMems: function(evt){
            },
            onClose: function(evt){
                attendee.onClose(evt.cver, evt.confrId);
            },
            onEvent: function(evt){
                attendee.onEvent(evt);
            },
            onStreamControl: function (evt) {
                attendee.onStreamControl(evt.cver, evt.streamId, evt.voff, evt.aoff, evt.sver);
            },
            onRoleUpdate: function(evt){
                attendee._onRoleUpdate(evt.role, evt.roleToken);
            },
            onRemoteControl: function (evt) {
                if(typeof evt.arg === 'string'){
                    evt.arg = JSON.parse(evt.arg);
                }
                if(evt.arg.op2 === 20 && evt.arg.pic && self._onCapturePicture.call(self, evt)){
                    return;
                }
                if(evt.arg.op2 === 30 && self._onRemotePannelControl){
                    try{
                        self._onRemotePannelControl.call(self, evt);
                        return;
                    }catch (e){
                        _logger.warn(e);
                    }
                }

                // 上麦申请
                if(evt.arg.op2 === 21){

                    let { memId:applicat_memId, nickName } = evt.arg;

                    if(!applicat_memId) { //申请者 memId
                        console.warn('onRequestToTalker not have memberId');
                        return
                    }

                    self._cache_receive_sessions.push(evt);//将接收到的session 存储

                    let { onRequestToTalker } = self.listeners.mgr;

                    let applicat = {memberId:applicat_memId, nickName}
                    if(
                        onRequestToTalker &&
                        typeof onRequestToTalker == 'function'
                    ) {
                        onRequestToTalker(
                            applicat, 
                            (memberId, talker_is_full_callback) => self.agreeRequestToTalker(memberId,talker_is_full_callback), 
                            memberId => self.refuseRequestToTalker(memberId), 
                        )
                    }
                    return;
                }

                // 主持人申请回调给管理员
                if(evt.arg.op2 === 22){

                    let { memId:applicat_memId, nickName } = evt.arg;

                    if(!applicat_memId) { //申请者 memId
                        console.warn('onRequestToAdmin not have memberId');
                        return
                    }

                    self._cache_receive_sessions.push(evt);//将接收到的session 存储

                    let { onRequestToAdmin } = self.listeners.mgr;
                    let applicat = {memberId:applicat_memId, nickName}
                    if(
                        onRequestToAdmin &&
                        typeof onRequestToAdmin == 'function'
                    ) {
                        onRequestToAdmin(
                            applicat, 
                            memberId => self.agreeRequestToAdmin(memberId), 
                            memberId => self.refuseRequestToAdmin(memberId), 
                        )
                    }
                    return;
                }

                // 静音或取消静音 接收消息
                if(evt.arg.op2 === 23) {
                    let callBack = self.listeners.mgr.onMuted;
                    if(
                        callBack &&
                        typeof callBack == 'function'
                    ) {
                        callBack()
                        return
                    }
                }
                if(evt.arg.op2 === 24) {
                    let callBack = self.listeners.mgr.onUnmuted;
                    if(
                        callBack &&
                        typeof callBack == 'function'
                    ) {
                        callBack()
                        return
                    }
                }


                _logger.warn("Not support remote control");

                var message = attendee.newMessage({
                    op: 1001,
                    tsxId: evt.tsxId,
                    memId: evt.memId,
                    arg: JSON.stringify(evt.arg),
                    result: evt && evt.arg && evt.arg.op2 === 30 ? -405 : -507,
                    msg: "Not support the remote control."
                });

                attendee.postMessage(message, function (rsp) {
                    _logger.warn("Send remote control response. the result = ", rsp.result, rsp.msg || "");
                });
            },
            onRecvRemoteMessage: function (evt) {
                attendee._onRecvRemoteMessage && attendee._onRecvRemoteMessage(evt.memId, evt.arg, evt);
            },

            // 402 session的回调 会议属性 和会议状态
            onConfrAttrsUpdated: session => {
                // 会议属性 cattrs 处理函数
                const cattrs_updated = evt => {
                    
                    if(!self.listeners.mgr){
                        return
                    }
                    let cattrs = self.listeners.mgr.catrrs || []; //内存中的 会议属性

                    function object_to_array(obj) {
                        let array = [];
    
                        for (let key in obj) {
                            let _item = {};
                            _item.key = key;
                            _item.val = obj[key];
                            _item.op = '';
                            array.push(_item);
                        }
    
                        return array;
                    };
    
                    function set_attrs(target_array, array) {
                        if(array.length == 0){
                            return target_array;
                        }
                    
                        array.forEach(item => { //有相同key的对象替换，没有则添加
                            let is_have = false;
                            target_array.forEach((target_item, index) => {
                                if(target_item.key == item.key) {
                                    target_array.splice(index, 1, item) //替换item
                                    is_have = true;
                                    return;
                                }
                    
                            })
                    
                            if(!is_have) {
                                target_array.push(item)
                            }
                        });
                        
                        return target_array;
                    }

                    // 返回的结构不同，处理
                    // 示例
                    /**
                     * 1. cattrs = {type:"MIXER"};
                     * 2. cattrs = [{key:'type',val:'MIXER',op:'UPDATE}]
                     * 3. 统一成 array 回调给前面
                     * */ 
    
                    if((evt.cattrs instanceof Array) == true){ 
                        cattrs = set_attrs(cattrs, evt.cattrs)
                    } else {
                        cattrs = object_to_array(evt.cattrs);
                    }
    
                    self.listeners.mgr.catrrs = cattrs; //将处理后的会议属性保存到内存
    
                    // 以下为回调
                    let onCallBack = self.listeners.mgr.onConfrAttrsUpdated;

                    if(
                        onCallBack && 
                        typeof onCallBack == 'function'
                    ) {
                        onCallBack = onCallBack.bind(self.listeners.mgr);
                        onCallBack(cattrs)
                    }

                }

                // 会议属性 cstate 处理函数
                const cstate_updated = evt => {
                    if(//会议状态为空 或者空对象
                        !evt.cstate || 
                        Object.keys(evt.cstate).length == 0
                    ){
                        return
                    }

                    let onCallBack = self.listeners.mgr.onConfrStateUpdated;
                    if(onCallBack && typeof onCallBack == 'function'){
                        onCallBack = onCallBack.bind(self.listeners.mgr);
                        onCallBack(evt.cstate);
                    }
                }
                

                // 收到回调判断是否有 某一个 cattrs 或者 cstate
                // 会议属性有两种结构
                // 对象或数组 不是空对象 或 空数组 才可以
                if(
                    (session.cattrs instanceof Array) == true && 
                    session.cattrs.length > 0
                ) { // 非空数组
                    cattrs_updated(session)
                }
                if(
                    session.cattrs.constructor == Object  && 
                    Object.keys(session.cattrs).length > 0
                ){ // 非空对象
                    cattrs_updated(session)
                }

                if(session.cstate){
                    cstate_updated(session)
                }


            },

            onAdminChanged: evt => {

                let onCallBack = self.listeners.mgr.onAdminChanged;
                if(
                    !onCallBack || 
                    typeof onCallBack != 'function'
                ) {
                    return
                }

                onCallBack(evt)
            },
           
            // 上麦申请的回复
            onRequestToTalkerReply: result => {
                let callback = self.listeners.mgr.onRequestToTalkerReply;

                if(
                    callback &&
                    typeof callback == 'function'
                ) {
                    callback(result)
                }

            },

            // 主持人申请的回复
            onRequestToAdminReply: result => {
                let callback = self.listeners.mgr.onRequestToAdminReply;

                if(
                    callback &&
                    typeof callback == 'function'
                ) {
                    callback(result)
                }

            },

            // 存储 liveCfgs
            onLivecfgsChanged: evt => {
                if(evt.liveCfgs) {
                    emedia.config({
                        liveCfgs: evt.liveCfgs
                    })
                }
            }

        });

        return session;
    },

    _judgeTalking: function (meter) {
        if(!meter){
            return false;
        }

        return meter.instant >= emedia.config.judgeTalkingByInstantGE;
    },

    graffitiVideo: function (streamId, videoTag, canvasTag) {
        var self = this;

        var hxStream = self.getStreamById(streamId);

        var mediaStream = new MediaStream();
        mediaStream._located = true;

        hxStream._localMediaStream.getAudioTracks().forEach(function(track) {
            mediaStream.addTrack(track);
        });

        var drawStream = canvasTag.captureStream(25);
        drawStream.getVideoTracks().forEach(function(track) {
            mediaStream.addTrack(track);
        });

        videoTag.srcObject = mediaStream;

        hxStream.updateAttributes({
            localStream: mediaStream,
            isRepublished: true,
            optimalVideoCodecs: hxStream.optimalVideoCodecs
        });
        self.push(hxStream);
    },

    resetCanvas: function (canvasTag) {
        var set;
        if(arguments.length > 1){
            for(var i = 0; i < arguments.length; i++){
                set = arguments[i];

                typeof set === "function" && set(canvasTag);
                typeof set !== "function" && _util.isPlainObject(set) && _util.forEach(set, function (key, value) {
                    _logger.debug("Canvas set ", key, " = ", value);
                    canvasTag.setAttribute(key, value);
                });
            }
        }
    },

    _random: function (c) {
        return Math.floor(Math.random() * c)
    },
    requestFrame: function (stream, millis) {
        var self = this;

        var _cacheStream;
        if(typeof stream === "string"){
            _cacheStream = this.current._cacheStreams[stream];
        }else if(stream.id){
            _cacheStream = this.current._cacheStreams[stream.id];
        }else{
            return;
        }

        if(!_cacheStream){
            return;
        }

        function _requestFrame() {
            _cacheStream.requestFrame();

            if(_cacheStream.canvas){
                var redraw = DefaultMouseTrack.prototype.redraw.bind({_canvasContext: _cacheStream.canvas.getContext("2d")});
                //_logger.debug(self._random(255));
                redraw(3, 3);
            }
        }

        if(!millis){
            _requestFrame();
            return;
        }

        setTimeout(function () {
            _requestFrame();
            self.requestFrame(_cacheStream, millis);
        }, millis)
    },

    graffitiCanvas: function (withVoice, canvasTag) {
        if(_util.targetDOM(withVoice)){
            canvasTag = withVoice;
            withVoice = false;
        }

        var self = this;

        var pubS = new self.ShareDesktopPubstream({
            voff: 0,
            aoff: withVoice ? 0 : 1
        });

        canvasTag || (canvasTag = document.createElement("canvas"));

        //canvasTag.getContext("2d", {willReadFrequently: true}); //Fixed: Firefox captureStream  NS_ERROR_NOT_INITIALIZED
        canvasTag.getContext("2d");
        pubS.canvas = canvasTag;

        var diy = function () {};
        diy.prototype.setCanvas = function(set){
            this.canvasTag = canvasTag;
            self.resetCanvas(canvasTag, set);

            return this;
        };

        diy.prototype.push = function (frameRate, _onpushed) {
            var diy = this;
            diy._push(frameRate, _onpushed);
        };
        diy.prototype._push = function (frameRate, _onpushed) {
            if(typeof frameRate === "function"){
                _onpushed = frameRate;
                frameRate = undefined;
            }

            canvasTag.captureStream && (canvasTag.captureStream.enabled = true);
            var drawStream = canvasTag.captureStream(frameRate || 25);

            function pushed(stream) {
                stream.canvas = canvasTag;
                _onpushed && _onpushed(stream, canvasTag, drawStream);

                if(withVoice){ //发送一帧视频
                    stream.requestFrame();
                }
            }

            function pub(pubS, pushed) {
                var mediaStream = new MediaStream();
                mediaStream._located = true;

                pubS._localMediaStream && pubS._localMediaStream.getAudioTracks().forEach(function(track) {
                    mediaStream.addTrack(track);
                });

                drawStream.getVideoTracks().forEach(function(track) {
                    mediaStream.addTrack(track);
                });

                pubS._localMediaStream = mediaStream;
                pubS.localStream = mediaStream;
                self.push(pubS, pushed);
            }

            if(withVoice){
                self.__getUserMedia({audio: true}, function success(_user, stream) {
                    pubS._localMediaStream = stream;
                    pub(pubS, pushed);
                });
            }else{
                pub(pubS, pushed);
            }

            return this;
        };

        return new diy();
    },

    blobRecorder: function (mediaStream, options, handleDataAvailable, handleStop) {
        var self = this;

        if(_util.targetDOM(mediaStream)){
            mediaStream = mediaStream.srcObject;
        }

        options || (options = {mimeType: 'video/webm;codecs=vp9'});
        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
            _logger.info(options.mimeType, ' is not Supported');
            options = {mimeType: 'video/webm;codecs=vp8'};
            if (!MediaRecorder.isTypeSupported(options.mimeType)) {
                _logger.info(options.mimeType, ' is not Supported');
                options = {mimeType: 'video/webm'};
                if (!MediaRecorder.isTypeSupported(options.mimeType)) {
                    _logger.info(options.mimeType, ' is not Supported');
                    options = {mimeType: ''};
                }
            }
        }

        try {
            var mediaRecorder = new MediaRecorder(mediaStream, options);
        } catch (e) {
            _logger.error('Exception while creating MediaRecorder: ', e);
            //alert('Exception while creating MediaRecorder: ' + e + '. mimeType: ' + options.mimeType);
            return;
        }
        var recordedBlobs = [];
        mediaRecorder.onstop = handleStop || function handleStop(event) {
            _logger.info('Recorder stopped: ', event);
        };
        mediaRecorder.ondataavailable = handleDataAvailable || function(event) {
            if (event.data && event.data.size > 0) {
                recordedBlobs.push(event.data);
            }
        };
        // mediaRecorder.start(10); // collect 10ms of data
        // _logger.error('MediaRecorder started', mediaRecorder);

        function BlobRecorder() {
            this.blobs = recordedBlobs;
        }
        BlobRecorder.prototype.start = function (secornds) {
            mediaRecorder.start(secornds);
        };
        BlobRecorder.prototype.stop = function () {
            mediaRecorder.stop();
        };
        BlobRecorder.prototype.playurl = function (options) {
            var superBuffer = new Blob(this.blobs, options || {type: 'video/webm'});
            return window.URL.createObjectURL(superBuffer);
        };
        BlobRecorder.prototype.download = function (filename, options) {
            var blobs = new Blob(this.blobs, options || {type: 'video/webm'});
            self.downloadFile(filename, undefined, blobs);
        };


        return new BlobRecorder();
    },

    // 申请上麦
    requestToTalker:function() {
        this.current.requestToTalker()
    },
    // 读取 _cache_session
    _get_session_by_memberId_and_op_type: function(memberId, op_type) {
        if(!memberId || !op_type){
            return undefined
        }

        let session = undefined;
        this._cache_receive_sessions.map(item => {
            let arg = item.arg;

            if(
                arg &&
                arg instanceof Object &&
                Object.keys(arg).length > 0
            ) {
                let { memId: applicant_memberId, op2:op } = arg;

                if( // 比较 memberId 和 op 都相等返回 session
                    applicant_memberId == memberId &&
                    op == op_type
                ) {
                    session = item
                }
            }
            
        });

        return session
    },
    // 删除 _cache_session
    _delete_session_by_memberId_and_op_type: function(memberId, op_type) {
        if(!memberId || !op_type){
            return
        }

        let _this = this;
        this._cache_receive_sessions.map((item, index) => {
            let arg = item.arg;

            if(
                arg &&
                arg instanceof Object &&
                Object.keys(arg).length > 0
            ) {
                let { memId: applicant_memberId, op2:op } = arg;

                if( // 比较 memberId 和 op 都相等 删除这一项
                    applicant_memberId == memberId &&
                    op == op_type
                ) {
                    _this._cache_receive_sessions.splice(index, 1)
                }
            }
            
        });

    },
    // 同意上麦
    agreeRequestToTalker: async function(memberId, talker_is_full_callback) {
        let session = this._get_session_by_memberId_and_op_type(memberId, 21);
        
        if(!session) {
            return
        }

        let { memName } = session.arg;
        let { confrId } = this.listeners;

        try {
            await this.listeners.mgr.chanageRoles(3, [memName], confrId);
        } catch (error) {
            if(error.error == -523){ //主播已满
                if(
                    talker_is_full_callback &&
                    typeof talker_is_full_callback == 'function'
                ) { //回调给使用者
                    talker_is_full_callback();
                    return  //主播满了不能删除 session
                }
            }
        }


        this._delete_session_by_memberId_and_op_type(memberId, 21)
    },
    // 拒绝上麦
    refuseRequestToTalker: function(memberId) {
        if(!memberId){
            console.warn('refuseRequestToTalker memberId is required');
            return
        }
        
        let session = this._get_session_by_memberId_and_op_type(memberId, 21);
        
        if(!session) {
            return
        }
        
        
        this.current.refuseRequestToTalker(session);

        this._delete_session_by_memberId_and_op_type(memberId, 21)
    },
    // 申请主持人
    requestToAdmin:function() {
        this.current.requestToAdmin()
    },
    // 同意成为主持人
    agreeRequestToAdmin: function(memberId) {
        let session = this._get_session_by_memberId_and_op_type(memberId, 22);
        
        if(!session) {
            return
        }

        let { memName } = session.arg;
        let { confrId } = this.listeners;
        this.listeners.mgr.chanageRoles(7, [memName], confrId);


        this._delete_session_by_memberId_and_op_type(memberId, 22)
    },
    // 拒绝成为主持人
    refuseRequestToAdmin: function(memberId) {
        if(!memberId){
            console.warn('refuseRequestToAdmin memberId is required');
            return
        }
        
        let session = this._get_session_by_memberId_and_op_type(memberId, 22);
        
        if(!session) {
            return
        }
        
        
        this.current.refuseRequestToAdmin(session);

        this._delete_session_by_memberId_and_op_type(memberId, 22)
    },
    // 指定静音
    muteBymemberId:function(memberId) {

        if(!this.current) {
            return
        }

        if(this.current.role != 7){
            return
        }
        
        this.current.muteBymemberId(memberId);
    },

    // 指定取消静音
    unmuteBymemberId:function(memberId) {
        if(!this.current) {
            return
        }

        if(this.current.role != 7) {
            return
        }
        
        this.current.unmuteBymemberId(memberId);
    }

    
});